import React from 'react';
import { ThemeProvider, CssBaseline, Box } from '@mui/material';
import { AppProvider, useApp } from './context/AppContext';
import { SnackbarProvider } from 'notistack';
import { AuthProvider } from './context/AuthContext';
import { getTheme } from './theme';

const AppTheme = ({ children }) => {
  const { darkMode } = useApp();
  const theme = getTheme(darkMode ? 'dark' : 'light');
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
};

const AppWithProviders = ({ children }) => (
  <SnackbarProvider
    maxSnack={3}
    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    autoHideDuration={2000}
    style={{ zIndex: 9999 }}
  >
    <AuthProvider>
      <AppProvider>
        <AppTheme>
          <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            {children}
          </Box>
        </AppTheme>
      </AppProvider>
    </AuthProvider>
  </SnackbarProvider>
);

export default AppWithProviders; 